export default __webpack_public_path__ + "static/imda20181stprize-5c74b0eb74dde0e712c2b95383dcaf31.jpg";